var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":201}}),_c('v-progress-linear',{attrs:{"active":_vm.active,"height":_vm.height,"color":"primary","indeterminate":"","rounded":"","absolute":"","striped":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }